import { render, staticRenderFns } from "./page-tab.vue?vue&type=template&id=55d05c3d&scoped=true&lang=pug&"
import script from "./page-tab.vue?vue&type=script&lang=js&"
export * from "./page-tab.vue?vue&type=script&lang=js&"
import style0 from "./page-tab.vue?vue&type=style&index=0&id=55d05c3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d05c3d",
  null
  
)

export default component.exports